export function setBranchOffices(state, branchOffices){
    state.branchOffices = branchOffices.data;
    console.log(branchOffices.data)
}
export function setBranchOfficesWarehouses(state, branchoffice_warehouses){
    state.branchoffice_warehouses = branchoffice_warehouses;
}
export function setReportMinMax(state, data){
    state.reportMinMax = data;
}
export function clearParams(state, data){
    state.params= {
        product_id: null,
        product_code: "",
        branch_office_id: Number(localStorage.selected_branchoffice),
        branch_office_warehouse_id: Number(localStorage.selected_branchoffice_warehouse),
        line_id: null,
        brand_id: null,
    }
}
export function setLines(state, lines){
    state.lines = lines
}
export function setBrands(state, brands){
    state.brands = brands
}




// WEBPACK FOOTER //
// ./src/modules/report-max-min/mutations.js